module.exports = __webpack_public_path__ + "assets/img/14_951_big.ae566c47.jpg";